import React, {PropTypes as T} from 'react';
import SIM from '../../../sim/core';
import Modal, {ModalHeader, ModalContent} from '../../common/modal';
import Button from '../../common/button';
import ModalCloseIcon from '../../common/icons/icon_close2';
import PriceType from './pricetype';
import translate from '../../../utils/translate';
import withDevice from '../../common/withDeviceHOC';
import pricesForSeat from '../../../utils/sim/prices_for_seat';
import EventTicketLimit from '../errors/event_ticket_limit';
import MemberTicketLimit from '../errors/member_ticket_limit_error';
import basketActions from '../../../actions/basket';
import noScroll from '../../../utils/noscroll';
import U from './pricetype_selector_utils';
import TicketFactory from '../../common/ticket_stub/ticket_stub_factory';

const mapActions  = SIM.actions.map;

class PriceTypeSelector extends React.Component {
  static propTypes = {
    unassignedSeat:        T.object,
    areaNames:             T.object,
    prices:                T.array,
    priceTypes:            T.object,
    config:                T.object,
    error:                 T.object,
    isBasketFull:          T.bool,
    isMemberLimitReached:  T.bool,
    attemptedToSelectSeat: T.bool,
    mandatoryUpsells:      T.array,
    moneyFormat:           T.string,
    currency:              T.string,
    isUnlockingPriceType:  T.oneOfType([T.bool, T.number]),
    priceTypeJustUnlocked: T.bool,
    isMobile:              T.bool,
    activeSeats:           T.object,
    feeRollup:             T.string
  };

  state = { isOpen: true };

  onClickOutside = () => {
    noScroll.off();
    basketActions.resetSelectSeatAttempt();
    const seatId = (this.props.unassignedSeat) ? this.props.unassignedSeat.id : null;
    mapActions.emit(mapActions.EVENTS.SEAT_REMOVE, seatId);
    this.setState({ isOpen: true });
  };

  closeModal = () => {
    this.setState({ isOpen: false, priceTypeJustUnlocked: false }, () => {
      setTimeout(this.onClickOutside, 300);
    });

  };

  renderPriceTypes = (prices) => {
    return prices.map(pt =>
      <PriceType
        key={pt.price.priceType}
        id={pt.price.priceType}
        eventId={this.props.config.eventId}
        price={pt.price}
        priceType={pt.priceType}
        mandatoryUpsells={this.props.mandatoryUpsells}
        moneyFormat={this.props.moneyFormat}
        currency={this.props.currency}
        isUnlockingPriceType={this.props.isUnlockingPriceType}
        activeSeats={this.props.activeSeats}
        prices={this.props.prices}
        feeRollup={this.props.feeRollup} />
    );
  };

  renderTicketInfo = () => {
    const ticket = U.unassignedSeatToTicket(this.props.unassignedSeat, this.props.areaNames);
    return TicketFactory.makePriceTypeSelectorTicketStub(ticket);
  };

  renderMemberTicketLimit = () => {
    return (
      <MemberTicketLimit
        memberTicketLimit={this.props.config.memberTicketLimit}
        translations={this.props.error.translations}
        onClose={this.onClickOutside} />
    );
  };

  renderEventTicketLimit = () => {
    const ticketLimit = this.props.config.ticketLimit;
    const modalTitle = translate('pageTranslations', 'CART_FULL_HEADER', {'%MAX_TICKETS%': ticketLimit});
    return (
      <EventTicketLimit
        title={modalTitle}
        ticketLimit={ticketLimit}
        onClickOutside={this.onClickOutside} />
    );
  };

  shouldRenderModal = (prices) => {
    // if no unassigned seat don't render
    if (!this.props.unassignedSeat) {
      return false;
    }

    if (prices.length === 1) {
      // If there is only 1 price type we want to add the ticket directly to the basket
      // but only if it is not a password protected price type or that it was previously unlocked
      const priceType = prices[0].priceType;
      return (
        priceType.isPasswordProtected &&
        !priceType.isUnlocked ||
        this.props.priceTypeJustUnlocked
      );
    }

    return prices.length !== 0;
  };

  render () {
    const {attemptedToSelectSeat, isMemberLimitReached, isBasketFull} = this.props;
    // MemberTicketLimit should have precedence over EventTicketLimit
    if (attemptedToSelectSeat && isMemberLimitReached) {
      return this.renderMemberTicketLimit();
    }

    // When trying to assign a seat and the basket is full, show notification message
    if (attemptedToSelectSeat && isBasketFull) {
      return this.renderEventTicketLimit();
    }

    const prices = pricesForSeat(this.props.unassignedSeat, this.props.prices, this.props.priceTypes);

    // if no unassigned seat or there is less than 2 prices, don't render anything
    // (unless password protected and not yet unlocked)
    if (!this.shouldRenderModal(prices)) {
      return <div />;
    }

    return (
      <Modal
        dataComponent="pricetype-selector-modal"
        isOpen={this.state.isOpen}
        onClose={this.closeModal}
        width={!this.props.isMobile && 480}
      >
        <ModalHeader isInfo>
          <div className="modal__header_title">
            {`${prices.length} ${translate('ismModule', 'TICKET_TYPES_AVAILABLE')}`}
          </div>
          <Button icon onClick={this.closeModal} data-component="modal__close_button">
            <ModalCloseIcon className="modal__header__close_icon" />
          </Button>
        </ModalHeader>
        <ModalContent seamless>
          <div className="ismmodal__header">
            {this.renderTicketInfo()}
          </div>
          <div className="ismmodal__options">
            {this.renderPriceTypes(prices)}
          </div>
        </ModalContent>
      </Modal>
    );
  }
}

export default withDevice(PriceTypeSelector);



// WEBPACK FOOTER //
// ./frontend/react/components/edp/pricetypeselector/index.js